"use client";

import { useNotificationStream } from "@/hooks/useNotificationStream";

/**
 * Mount once inside the authenticated app tree. Opens the live notification SSE
 * stream and invalidates notification queries when the server signals a change.
 * Renders nothing; self-gates on auth via `useNotificationStream`.
 */
export default function NotificationStreamManager() {
  useNotificationStream();
  return null;
}
